const REGIONS_START = 'REGIONS_START';
const REGIONS_SUCCESS = 'REGIONS_SUCCESS';
const REGIONS_ERROR = 'REGIONS_ERROR';

export { REGIONS_ERROR, REGIONS_START, REGIONS_SUCCESS };
